<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard>
          <v-layout justify-start align-content-start row wrap>
            <v-flex xs12>
              <h4>App Versions</h4>
            </v-flex>
            <v-flex xs6>
              <v-layout row align-center>
                <v-text-field
                  type="number"
                  v-model="androidCustomerVersion"
                  label="Android Customer Version"
                  min="0"
                ></v-text-field>
              </v-layout>
              <v-layout row align-center>
                <v-text-field
                  type="number"
                  v-model="iosCustomerVersion"
                  label="iOS Customer Version"
                  min="0"
                ></v-text-field>
              </v-layout>
              <v-layout row align-center>
                <v-text-field
                  type="number"
                  v-model="androidDriverVersion"
                  label="Android Driver Version"
                  min="0"
                ></v-text-field>
              </v-layout>
              <v-layout row align-center>
                <v-text-field
                  type="number"
                  v-model="iosDriverVersion"
                  label="iOS Driver Version"
                  min="0"
                ></v-text-field>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-btn @click="updateVersions" small>Update</v-btn>
            </v-flex>
          </v-layout>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import qs from "qs";

export default {
  name: "versions",
  components: {
    Overview,
    SimpleCard
  },
  data: function() {
    return {
      loading: false,
      androidCustomerVersion: null,
      iosCustomerVersion: null,
      androidDriverVersion: null,
      iosDriverVersion: null
    };
  },
  mounted: async function() {
    this.get();
  },
  methods: {
    get: function(p) {
      this.loading = true;

      var url = `${this.$store.state.apiUrl}/settings/apps/versions/get`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            vm.androidCustomerVersion = res.data.android_customer_version;
            vm.iosCustomerVersion = res.data.ios_customer_version;
            vm.androidDriverVersion = res.data.android_driver_version;
            vm.iosDriverVersion = res.data.ios_driver_version;
          } else {
            alert("Failed to get settings");
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
          console.error(err);
        });
    },
    updateVersions: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/settings/apps/versions/update?android_customer_version=${this.androidCustomerVersion}&ios_customer_version=${this.iosCustomerVersion}&android_driver_version=${this.androidDriverVersion}&ios_driver_version=${this.iosDriverVersion}`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            alert("App Versions updated");
          } else {
            alert("Failed to update app versions: " + res.data.error.message);
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
        });
    }
  }
};
</script>
